import cookieUtil from 'tradera-utils/cookie';
import GdprSettings from 'tradera-utils/gdpr-settings';
import { LANGUAGE_TOOLTIP_DISMISSED_COOKIE } from 'tradera-constants/cookies';

const getInitialPreferredLanguage = (
    languageCodeIso2,
    availableLanguages,
    defaultLanguage
) => {
    const availableIsoCodes = availableLanguages.map(
        lang => lang.languageCodeIso2
    );
    if (
        !!languageCodeIso2 &&
        availableIsoCodes.indexOf(languageCodeIso2) !== -1
    ) {
        return availableLanguages.find(
            l => l.languageCodeIso2 === languageCodeIso2
        );
    }

    return defaultLanguage;
};

export default initData => {
    const showLanguageSelection = initData && initData.showLanguageSelection;

    if (!showLanguageSelection) {
        return {
            showLanguageSelection,
            shouldDisplayInHeader: false,
            shouldAlwaysDisplayInMenu: false,
            preferred: getInitialPreferredLanguage(
                initData.languageCodeIso2,
                initData.availableLanguages,
                initData.defaultLanguage
            ),
            available: initData.availableLanguages,
            showTooltip: false,
            showOptoutTooltip: false
        };
    }

    const showOptoutTooltip =
        GdprSettings.isFunctionalEnabled() &&
        initData.languageCodeIso2 === 'en' &&
        initData.memberCountry !== 'Sverige' &&
        !cookieUtil.readCookie(LANGUAGE_TOOLTIP_DISMISSED_COOKIE);

    const showTooltip =
        GdprSettings.isFunctionalEnabled() &&
        initData.languageCodeIso2 !== 'en' &&
        initData.memberCountry !== 'Sverige' &&
        !cookieUtil.readCookie(LANGUAGE_TOOLTIP_DISMISSED_COOKIE);

    const shouldDisplayInHeader = initData.memberCountry !== 'Sverige';
    const shouldAlwaysDisplayInMenu = initData.memberCountry === 'Sverige';

    return {
        showLanguageSelection,
        shouldDisplayInHeader,
        shouldAlwaysDisplayInMenu,
        preferred: getInitialPreferredLanguage(
            initData.languageCodeIso2,
            initData.availableLanguages,
            initData.defaultLanguage
        ),
        available: initData.availableLanguages,
        showTooltip: showTooltip,
        showOptoutTooltip: showOptoutTooltip
    };
};
